import { render } from "./StandAloneAccountability.vue?vue&type=template&id=5be3bea3&scoped=true"
import script from "./StandAloneAccountability.vue?vue&type=script&lang=js"
export * from "./StandAloneAccountability.vue?vue&type=script&lang=js"

import "./StandAloneAccountability.vue?vue&type=style&index=0&id=5be3bea3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be3bea3"]])

export default __exports__